import { render } from "./ArticleDetail.vue?vue&type=template&id=27cda356&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"

import "./ArticleDetail.vue?vue&type=style&index=0&id=27cda356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cda356"]])

export default __exports__